import * as React from 'react';
import { Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './clinical-review-link.css';

const CLINICAL_REVIEW_URL = 'https://labsmarts.com/clinical-review/';

// Right-aligned call to action in the dark navbar. Styled as an outlined pill
// rather than a plain nav link so it reads as an offer (a paid 30/60 minute
// session with our clinical educator) instead of another menu item.
//
// This is the only group in the bar carrying `ml-auto`; everything else,
// Account included, sits in the left-hand nav. A second auto margin anywhere to
// its left would split the free space and pull this pill in from the edge.
export const ClinicalReviewLink: React.FC = () => (
  <Nav className="ml-auto align-items-center">
    <Nav.Item>
      <a
        className="clinical-review-link"
        href={CLINICAL_REVIEW_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon="calendar-check" className="mr-3" />
        <span>Book a Clinical Review</span>
      </a>
    </Nav.Item>
  </Nav>
);
